/** Constantes do domínio cart (carrinho e cupom). */

/**
 * Marcador de "nenhum cupom escolhido" na useCouponStore (valor que o legado grava e compara). O `checkout/create`
 * manda `null` no lugar dele.
 */
export const NO_COUPON = 'Sem cupom'
